<div class="widget-order-confirm_wrapper">

  <!--Confirm Title-->
  <div class="widget-order-confirm_title">{{widgetOrderConfirmModalInfo.title | l10n}}</div>

  <!--Confirm Cancel/Place/Replace group or single orders-->
  <div class="widget-order-confirm_info" ngPreserveWhitespaces>
    <span class="-info-text" [ngClass]="CLASS_BY_SIDE_MAP[widgetOrderConfirmModalInfo.side]">{{widgetOrderConfirmModalInfo.side | l10n}}</span>
    @if (widgetOrderConfirmModalInfo.quantity?.value) {
      <span class="-value {{widgetOrderConfirmModalInfo.quantity?.class}}"
      >{{widgetOrderConfirmModalInfo.quantity?.value}}</span>
    }
    <display-symbol [security]="widgetOrderConfirmModalInfo.security"></display-symbol>
    @if (widgetOrderConfirmModalInfo.price?.value) {
      <div class="-info-text">
        <span> &#64;</span><span class="-value {{widgetOrderConfirmModalInfo.price?.class}}">{{widgetOrderConfirmModalInfo.price?.value}}</span>
      </div>
    }

    @if (widgetOrderConfirmModalInfo.accountNames?.length && widgetOrderConfirmModalInfo.accountNames[0]) {
      <span class="-info-text">{{'components.widget-order-confirm-modal.cancel_for_word' | l10n}}</span>
      <span class="-info-text">{{widgetOrderConfirmModalInfo.accountNames[0]}}</span>
    }

    <div class="-form">
      @if (isInvPortfoliosAvailable) {
        <div class="-inv-entity">
          <label class="-leverage-label" #invEntityLabelEl>
            {{'components.investment-portfolio.investment_entity_label' | l10n}}
          </label>
          <inv-entity-id-select
            class="-inv-entity-value"
            [formControl]="form.controls.investmentEntityId"
            [labelElement]="invEntityLabelEl">
          </inv-entity-id-select>
        </div>
        <div class="-portfolio">
          <label class="-portfolio-label" #portfolioLabelEl>
            {{'components.investment-portfolio.portfolio_label' | l10n}}
          </label>
          <portfolio-id-select
            class="-portfolio-value"
            [formControl]="form.controls.portfolioId"
            [invEntityId]="form.controls.investmentEntityId.value"
            [labelElement]="portfolioLabelEl">
          </portfolio-id-select>
        </div>
      }

      @if (isLeverageSelectable) {
        <div class="-leverage">
          <label class="-leverage-label" #leverageLabelEl>
            {{'components.leverage.leverage_label' | l10n}}
          </label>
          <leverage-select
            class="-leverage-value"
            [formControl]="form.controls.leverage"
            [securityKey]="widgetOrderConfirmModalInfo.security"
            [accountBase]="accountBase"
            [side]="oppositeSide"
            [labelElement]="leverageLabelEl">
          </leverage-select>
        </div>
      }
    </div>
  </div>

  <!--Confirm Button-->
  <button class="widget-order-confirm_button"
    (click)="confirm()">
    {{'components.widget-order-confirm-modal.confirm' | l10n}}
  </button>

  <svg class="close-control_icon" (click)="close()"><use xlink:href="#close"></use></svg>
</div>
